export function isNullOrUndefined(value) {
  return value === null || value === undefined;
}

export function isNullUndefinedOrEmptyString(value) {
  return isNullOrUndefined(value) || value === "";
}

export function isFiniteNumber(value) {
  if (isNullUndefinedOrEmptyString(value)) return false;
  return Number.isFinite(Number(value));
}

export function positiveFiniteNumberOr(value, fallback) {
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? n : fallback;
}

export function trimmedString(value) {
  if (isNullOrUndefined(value)) return "";
  return String(value).trim();
}

export function trimmedParam(params, field) {
  return trimmedString(params?.[field]);
}
